import { DownloadIcon } from "@chakra-ui/icons";
import {
  Box,
  Link as ChakraLink,
  Container,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { Breadcrumbs } from "@nens/ldo/components";

export function ApiPage() {
  const intl = useIntl();

  return (
    <Box w="full" h="full">
      <Breadcrumbs
        crumbs={[
          { label: intl.formatMessage({ id: "pages.home", defaultMessage: "Home" }), href: "/" },
          {
            label: intl.formatMessage({ id: "pages.api", defaultMessage: "API" }),
            href: "/api",
          },
        ]}
      />
      <Container maxW={"7xl"} py={"24px"} justifyItems="center">
        <Tabs h="full" w="full">
          <TabList>
            <Tab>
              <FormattedMessage id="pages.api.tabs.information" defaultMessage="Information" />
            </Tab>
            <Tab>
              <FormattedMessage id="pages.api.tabs.guide" defaultMessage="Documentation" />
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <Heading mb={3}>
                <FormattedMessage id="pages.api.tabs.information" defaultMessage="Information" />
              </Heading>
              <ChakraLink href={`/auth`} fontWeight="semibold">
                Authentication API
              </ChakraLink>
              <Text m={4}>
                <FormattedMessage
                  id="steps.api.explanation_auth"
                  defaultMessage="The Authentication API can be used to set up a session for interfacing with LDO."
                />
              </Text>
              <ChakraLink href={`/api/v1/docs`} fontWeight="semibold">
                Backend API
              </ChakraLink>
              <Text m={4}>
                <FormattedMessage
                  id="steps.api.explanation_backend"
                  defaultMessage="The Backend API can be used to manipulate imports, exports and scenarios."
                />
              </Text>
            </TabPanel>
            <TabPanel>
              <Heading mb={3}>
                <FormattedMessage id="pages.api.tabs.guide" defaultMessage="Documentation" />
              </Heading>
              <ChakraLink href="/assets/docs/LDO-handleiding.pdf" fontWeight="semibold">
                Handreiking gebruik van de Application Programming Interface (API)
                <DownloadIcon mx="6px" />
              </ChakraLink>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Container>
    </Box>
  );
}
